import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { Attribute } from "models/profile/Attribute";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { addAttributeDO, getAttributes } from "utils/attributesUtil";
import { Autocomplete, TextField, Tabs, Tab, Box, Grid } from "@mui/material";
import { updateQuestion } from "utils/questionsUtils";
import { Question } from "models/batch/Question";

const MDInput = require("components/MDInput").default;

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`attribute-tabpanel-${index}`}
            aria-labelledby={`attribute-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export const CreateAttributeModal = ({question}: {question: Question}) => {
    const [attribute, setAttribute] = useState({} as Attribute);
    const [existingAttributes, setExistingAttributes] = useState<Attribute[]>([]);
    const [tabValue, setTabValue] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        getAttributes().then(setExistingAttributes);
    }, []);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
        setAttribute({} as Attribute);
    };

    const addAttribute = async () => {
        if (tabValue === 1 && attribute.id) {
            question.profileAttr = attribute.name;
            await updateQuestion(question.id, question);
            navigate(`/attributes/${attribute.name}`);
            return;
        }
        
        // Create new attribute
        attribute.editingQuestionId = question.id;
        await addAttributeDO(attribute);
        navigate(`/attributes/${attribute.name}`);
    };

    return (
        <AloveDialog
            dialogType={DialogType.AddAttribute}
            dialogTitle="Add Attribute"
            handleConfirm={addAttribute}
            dialogConfirm={tabValue === 0 ? "Add" : "Select"}
            valid={tabValue === 0 ? (!!attribute?.name && !!attribute?.txtId) : !!attribute?.id}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="attribute tabs">
                <Tab label="Create New" />
                <Tab label="Select Existing" />
            </Tabs>

            <TabPanel value={tabValue} index={0}>
                <Grid container gap={2} flexDirection="column">
                <MDInput
                    fullWidth
                    label="key"
                    placeholder="key"
                    value={attribute?.name}
                    onChange={(e) => setAttribute({ ...attribute, name: e?.target?.value } as Attribute)}
                    />
                    <MDInput
                        fullWidth
                        label="Display name"
                        placeholder="Display name"
                        value={attribute?.txtId}
                        onChange={(e) => setAttribute({ ...attribute, txtId: e?.target?.value } as Attribute)}
                    />
                </Grid>
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
                <Autocomplete
                    options={existingAttributes}
                    getOptionLabel={(option: Attribute) => option.txt || option.name}
                    onChange={(_, value: Attribute | null) => {
                        setAttribute(value || {} as Attribute);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Select Attribute"
                            margin="normal"
                        />
                    )}
                />
            </TabPanel>
        </AloveDialog>
    );
}